module.exports = __webpack_public_path__ + "media/images/logo-payoff-ad95cfec0d2b2791a84ba4057a030bd2.svg";